import classNames from 'classnames';
import c from './text-block.module.scss';

const TextBlock = ({ label, value, smallGap }) => {
  const classes = classNames(c.textBlock, { [c.smallGap]: smallGap });
  return (
    <div className={classes}>
      <div className={c.label}>{label}</div>
      <div>{value}</div>
    </div>
  );
};

export default TextBlock;
